// import { GameData } from "../../firecubes/gamestate/gameData";
import { CommonData } from "../datastructures/gamestate/gameData";
import GameVersion from "../gameLib/Singleton/versionSingleton";
import {
  muteSound,
  disableFHD,
  toggleFullHD,
  disable60Fps,
  toggle60Fps,
} from "./Function_settingsPage";

export function setCookie(
  cname: string,
  cvalue: string | number | boolean,
  exdays: number
) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

  // console.log('write to cookies', cname,cvalue)
}

export function getCookie(cname: string) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function generateVersion() {
  const singleton = GameVersion.getInstance();

  return singleton.version;
}

export function checkCookie(activeGameData: CommonData) {
  // var music = getCookie("music");
  // var music2 = getCookie("bonusMusic");
  var sound = getCookie("sound");
  var fullhd = getCookie("fullhd");
  var fpslimit = getCookie("fpslimit");

  // console.log(document.cookie)
  //-----------------------read music from cookie

  // if (music != "") {

  //     // console.log("read", music);
  //     let bool = false;
  //     if (music == "true") {
  //         bool = true;

  //     }
  //     muteMusic(activeGameData, bool);
  //     setCookie("music", bool, 365);

  // }
  // else {

  //     // setCookie("usersettings", music, 365);
  //     // console.log("noCookiesFound")
  //     toggleMuteOption(activeGameData)
  // }

  //--   //-----------------------read music from cookie

  // if (music2 != "") {

  //     // console.log("read", music);
  //     let bool = false;
  //     if (music2 == "true") {
  //         bool = true;

  //     }
  //     muteMusic2(activeGameData, bool);
  //     setCookie("bonusMusic", bool, 365);

  // }
  // else {

  //     // setCookie("usersettings", music, 365);
  //     // console.log("noCookiesFound")
  //     // toggleBonusMusicOption(activeGameData)
  // }

  //-----------------------read sound from cookie
  if (sound != "") {
    // console.log("read", sound);
    let bool = false;
    if (sound == "true") {
      bool = true;
    }
    muteSound(activeGameData, bool);
    setCookie("sound", bool, 365);
  } else {
    // setCookie("usersettings", music, 365);
    // console.log("noCookiesFound")
    // changeSoundVolume(activeGameData)
  }

  //-----------------------read FHD from cookie
  if (fullhd != "") {
    // console.log("read", fullhd);
    let bool = false;
    if (fullhd == "true") {
      bool = true;
    }
    disableFHD(activeGameData, bool);
    setCookie("fullhd", bool, 365);
  } else {
    // setCookie("usersettings", music, 365);
    // console.log("noCookiesFound")
    toggleFullHD(activeGameData); //old
  }

  //-----------------------read 60fps from cookie
  if (fpslimit != "") {
    // console.log("read", fpslimit);
    let bool = false;
    if (fpslimit == "true") {
      bool = true;
    }
    disable60Fps(activeGameData, bool);
    setCookie("fpslimit", bool, 365);
  } else {
    // setCookie("usersettings", music, 365);
    // console.log("noCookiesFound")
    toggle60Fps(activeGameData);
  }
}
